import styled from '@emotion/styled'
import {
  boxShadow,
  BoxShadowProps,
  color,
  ColorProps,
  display,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  zIndex,
  ZIndexProps
} from 'styled-system'
import React from 'react'

export type BoxProps = SpaceProps &
  ColorProps &
  LayoutProps &
  ZIndexProps &
  PositionProps &
  TypographyProps & {
  as?: string
  id?: string
  className?: string
  href?: string
}

const Box: React.FC<BoxProps> = styled.div(
  {
    boxSizing: 'border-box',
    minWidth: 0
  },
  space,
  color,
  layout,
  zIndex,
  position,
  typography,
  display
)

export type FlexProps = SpaceProps &
  ColorProps &
  LayoutProps &
  FlexboxProps &
  ZIndexProps &
  PositionProps &
  BoxShadowProps &
  TypographyProps & {
  as?: string
  id?: string
  className?: string
}

const Flex: React.FunctionComponent<FlexProps> = styled.div`
  display: flex;
  ${space};
  ${color};
  ${layout};
  ${flexbox};
  ${zIndex};
  ${position};
  ${typography};
  ${boxShadow};
`

export { Box, Flex }
